module.exports = __webpack_public_path__ + "static/media/icon-mail.aa863106.svg";